// Change filter button text based on what's selected
function updateFilterButtonText(el, origText) {
	var $el = $(el),
		toggleBtn = $el.find('.dropdown-toggle'),
		checkedAmount = $el.find('input:checked').length,
		firstCheckedEl = $el.find('input:checked:eq(0)').closest('label'),
	    secondCheckedEl = $el.find('input:checked:eq(1)').closest('label');

	toggleBtn.each(function() {
		var $this = $(this),
			dataText = $this.text();

		if (checkedAmount === 1) {
			$this
				.text(firstCheckedEl.text())
				.addClass('has-filters-selected');
		} else if (checkedAmount === 2) {
			$this
				.text(firstCheckedEl.text() + ', ' + secondCheckedEl.text())
				.addClass('has-filters-selected');
		} else if (checkedAmount >= 3) {
			$this
				.text(checkedAmount + ' selected')
				.addClass('has-filters-selected');
		} else {
			$this.text(origText)
				.removeClass('has-filters-selected');
		}
	});
}

$(function() {

	// Initialize select to dropdown function
	if ($('#locationRegionSelect').length) {
		$('#locationRegionSelect').selectToDropdown();
	}

	// Update button text on load
	updateFilterButtonText('.checkbox-group-dropdown', 'Any Service');
});

// Prevent dropdown from closing when clicking inside of it and update it's text
$(document).on('click', '[name="locationServices"], label.dropdown-menu-item', function(e) {
	e.stopPropagation();
	updateFilterButtonText('.checkbox-group-dropdown', 'Any Service');
});

// Filter dropdown is cut by bottom of viewport scroll bottom of viewport to it
$('.checkbox-group-dropdown, .select-to-dropdown').on('shown.bs.dropdown', function() {
	var dropdown = $(this),
		dropdownEl = dropdown.find('.dropdown-menu'),
		windowHeight = $(window).innerHeight(),
		bottomOfViewport = $(window).scrollTop() + windowHeight,
		dropdownBottomCoord = dropdownEl.outerHeight() + (dropdownEl.offset().top),
		scrollBottomCoord = dropdownBottomCoord - windowHeight;

	if (dropdownBottomCoord > bottomOfViewport) {
		$('html, body').animate({
			scrollTop: scrollBottomCoord + 20
		}, 250);
	}
});

// Location filter collapse button text replacer
function textReplacer(el) {
	el.each(function() {
		var $this = $(this),
			text = $this.text();

		$this
			.text($this.data('text-replace'))
			.data('text-replace', text);
	});
}

// More Filter Options related
$('#moreFilterOptions').each(function() {
	var $this = $(this),
		moreFilterOptionsID = $(this).attr('id'),
		moreFiltersButton = $('[href="#' + moreFilterOptionsID + '"]');

	$this
		.on('show.bs.collapse', function() {
			textReplacer(moreFiltersButton);
		})
		.on('hide.bs.collapse', function() {
			textReplacer(moreFiltersButton);
		});
});


// Location cabinet
var ariaEpandedValue = false;
$('.locations-list-toggle').on('click', function() {
	var $this = $(this);

	ariaEpandedValue = (ariaEpandedValue === false) ? true : false;

	$this.attr('aria-expanded', ariaEpandedValue);

	$('.locations-list-cabinet')
		.toggleClass('showing')
		.addClass('transitioning')
		.find('.locations-list-drawer')
		.one('transitionend webkitTransitionEnd oTransitionEnd', function() {
			$(this)
				.closest('.locations-list-cabinet')
				.removeClass('transitioning');

			// Scroll to top of locations list toggle button if top of map is out of viewport
			if (document.querySelector('.map-container').getBoundingClientRect().top < 0 && $this.is('[aria-expanded="true"]')) {
				$('html, body').animate({
					scrollTop: $(this).offset().top - 66
				}, 250);
			}
		})
		.children().on('transitionend webkitTransitionEnd oTransitionEnd', function() {
			return false;
		});
});

// Map related
(function($) {
	$('#zero-results-card').hide();
	
	var zoomLevel = ($('.locations-list > li').length === 1) ? 13 : 10;

	window.initLocationsMap = function() {
		function parseLatLng(rawValue) {
			var split = rawValue.split(',');
			return {
				lat: parseFloat(split[0], 10),
				lng: parseFloat(split[1], 10)
			};
		}


		var mapElement = document.getElementById('locmap-map');
		var startLocation = parseLatLng($(mapElement).data('default-geometry'));
		var mobileSection = document.getElementById('mobile-details');
		var curMarker;
		var map = new google.maps.Map(mapElement, {
			center: startLocation,
			zoom: zoomLevel,
			styles: [{
				stylers: [{
					saturation: -100
				}]
			}]
		});

		
		google.maps.event.addListenerOnce(map, 'bounds_changed', function() { this.setZoom(Math.min(13, this.getZoom())); });

		var bounds = new google.maps.LatLngBounds();

		var infoWindow = new google.maps.InfoWindow({
			content: ''
		});

		function checkWindowResize(inMap, inMarker) {
			if (window.windowWidth >= 992) {
				infoWindow.open(inMap, inMarker);
			} else {
				infoWindow.close();
			}
		}

		window.addEventListener('resize', checkWindowResize(map, curMarker));

		var locations = 0;
		var lastLocation = null;
		$('[data-place-id]').not('[data-place-geometry=","], [data-place-id=""]').each(function() {
			locations += 1;
			var result = $(this);

			var data = {
				driveUpHours: result.data('drive-up-hours'),
				lobbyHours: result.data('lobby-hours'),
				placeId: result.data('place-id'),
				image: result.data('image'),
				geometry: parseLatLng(result.data('place-geometry')),
				geometryAsString: result.data('place-geometry'),
				title: result.find('h3').text(),
				addressHtml: result.find('p').html(),
				mailingAddress: result.data('mailing-address'),
				linkToItem: result.data('link-to-item'),
				locationType: result.data('location-type')
			};
			lastLocation = data;
			bounds.extend(data.geometry);
			var marker = new google.maps.Marker({
				map: map,
				position: data.geometry,
				title: data.title
			});

			marker.addListener('click', function() {
				infoWindow.setContent(
						// info window left
					"<div class=\"info-window-left\">" +
						(data.image ? ('<img style="margin-bottom: 7px" src="' + data.image + '" alt=\"\" class=\"info-window-image\" /><br />') : '') +
						(data.image ? ('<strong class="red fs-12px h6" style="display: block">' + data.title + '</strong>') : '') +
						(data.locationType === "Branch" ? '<p class="fs-12px">' + data.mailingAddress + '</p>' : '') +
						'<a class="fs-12px" href="https://www.google.com/maps/search/?api=1&amp;query=' + data.geometryAsString + '&amp;query_place_id="' + data.placeId + '">Get Directions ></a>' +
					"</div>" +

						// info window middle
					"<div class=\"info-window-two-third clearfix\">" +
						(data.locationType === "ATM" ? '<strong class="red fs-12px h6" style="display: block">Address</strong>' + data.mailingAddress : "") +
						(data.driveUpHours ? ('<strong class="red fs-12px h6" style="display: block">Hours</strong>') : '') +

						// info window middle
						"<div class=\"info-window-middle\">" +
							(data.driveUpHours ? ('<strong>Drive-Thru Hours</strong><p>' + data.driveUpHours + '</p>') : '') +
							(data.locationType != "ATM" ? '<a class="fs-12px" href="' + data.linkToItem + '">Location Details  ></a>' : "") +
						"</div>" +

						// info window right 
						"<div class=\"info-window-right\">" +
                            (data.lobbyHours ? ('<strong>Lobby Hours</strong><br>' + '<p class="fs-12px">' + data.lobbyHours + '</p>') : '') +
						"</div>") +
					"</div>";


				checkWindowResize(map, marker);
				curMarker = marker;

				// Sets content of window section when resized to mobile
				mobileSection.innerHTML =

					// Image
					(data.image ? ('<img class=\"img-responsive\" src=\"' + data.image + '\" alt=\"\">') : '') +

					// Mailing Address
					(data.title ? ('<h4 class="red text-center fs-14px" style="margin-top: 20px;">' + data.title + '</h4>') : '') +
					(data.mailingAddress ? ('<div class="text-center fs-14px">' + data.mailingAddress + '</div>') : '') +
					'<div class="text-center"><a class="fs-14px" href="https://www.google.com/maps/search/?api=1&amp;query=' + data.geometryAsString + '&amp;query_place_id="' + data.placeId + '">Get Directions ></a></div>' +

					// Hours
					(data.driveUpHours || data.lobbyHours ? ('<hr><h5 class="red fs-14px">Hours</h5>') : '') +
					'<div class="row fs-14px">' +
                        '<div class="col-xs-6">' +
                            (data.driveUpHours ? ('<h6 class="fs-14px">Drive-Thru Hours</h6>' + '<p>' + data.driveUpHours + '</p>') : '') +
                            (data.linkToItem ? ('<a class="location-details-link" href="' + data.linkToItem + '">Location Details ></a>') : '') +
                        '</div>' +

                        (data.lobbyHours ? ('<div class="col-xs-6">') : '') +
                            (data.lobbyHours ? ('<h6 class="fs-14px">Lobby Hours</h6>' + '<p>' + data.lobbyHours + '</p>') : '') +
                        (data.lobbyHours ? ('</div>') : '') +
					'</div>';


				var hours = $('#locmap-location-hours');
				if (data.driveUpHours || data.lobbyHours) {
					if (data.driveUpHours) {
						$('#locmap-drive-up')
							.html('<h5>Drive-Up Hours</h5>' + data.driveUpHours)
							.show();
					} else {
						$('#locmap-drive-up').hide();
					}
					if (data.lobbyHours) {
						$('#locmap-lobby')
							.html('<h5>Lobby Hours</h5>' + data.lobbyHours)
							.show();
					} else {
						$('#locmap-lobby').hide();
					}
					hours.show();
				} else {
					hours.hide();
				}

				// Scroll to location details on mobile when pin is clicked
				if ($(window).width() < 768) {
					$('html, body').animate({
						scrollTop: $('.locations-map-details').offset().top - 30
					}, 500);
				}
			});

		});
		
		if (locations > 1) {
			map.fitBounds(bounds);
		}

        // No results related
		if (locations === 0) {
			$('#locationsListCabinent > div > button').hide();
			$('#locmap-map').addClass("map_no_results");
			$('#zero-results-card').show();
		} else if (locations === 1) {
			map.panTo(lastLocation.geometry);
		}

		google.maps.event.addListenerOnce(map, 'idle', function() {
			var mapEl = $('#locmap-map');

            // Remove info window showing class
			$(document).on('click', function() {
				mapEl
					.find('.js-iw-showing')
					.removeClass('js-iw-showing');
			});

			// Open infowindow on list item click
			$('.locations-list h3').on('click', function(e) {
				$('.js-iw-showing').removeClass('js-iw-showing');

				var $this = $(this),
					titleText = $this.text();

				setTimeout(function() {
					if ($(window).width() < 992) {
						$('.locations-list-toggle').trigger('click');
					}

					$('#locmap-map [title="' + titleText + '"]')
						.addClass('js-iw-showing')
						.trigger('click')
						.closest('div')
						.addClass('js-iw-showing');
				}, 100);
			});
		});
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function (position) {
				var shortestPoint = new google.maps.LatLng(startLocation.lat, startLocation.lng);
				var userLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
				var shortestDistance = google.maps.geometry.spherical.computeDistanceBetween(userLatLng, shortestPoint);

				$('[data-place-id]').not('[data-place-geometry=","], [data-place-id=""]').each(function() {
					var $place = $(this);
					var geometry = parseLatLng($place.data('place-geometry'));
					var placeLocation = new google.maps.LatLng(geometry.lat, geometry.lng);
					var distance = google.maps.geometry.spherical.computeDistanceBetween(userLatLng, placeLocation);
					if(distance < shortestDistance){
						shortestPoint = placeLocation;
						shortestDistance = distance;
					}
	
				});

				map.setCenter(shortestPoint);
				map.setZoom(11);
			});
		}
	};
})(jQuery);